define('modules/content_recommendations/content_recommendations_filter_model',['backbone', '_', 'session'], function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      campaignType: 'tacticaloffer',
      campaignPeriod: 'not_ended',
      zoneOptions: null,
      searchText: '',
      filterByTemplate: false
    },
    parse: function (data) {
      return {
        zoneOptions: {
          active: [],
          options: data.zoneOptions,
        },
        searchText: data.searchText || '',
      };
    },
    url: function () {
      return session.get('apiUrl') + 'campaignfilters';
    },
  });

  return Model;
});
